export const AUTHORIZATION = 'AUTHORIZATION';
export const CAPTURE = 'CAPTURE';
export const PURCHASE = 'PURCHASE';
export const CHARGE_BALANCE = 'CHARGE_BALANCE';
export const TOPUP_ACCOUNT = 'TOPUP_ACCOUNT';
export const REFUND = 'REFUND';
